export default "__VITE_ASSET__n_94jVJQ__"